import type { UserSettings } from '@/entities/user';
import { apiClient } from '@/shared/api/api-client';
import type { ApiResponse } from '@/shared/api/types';

export const settingsApi = {
  getSettings: async (): Promise<UserSettings> => {
    const response = await apiClient.get<ApiResponse<UserSettings>>('/v1/user/settings');
    return response.data.data;
  },

  updateSettings: async (settings: Partial<UserSettings>): Promise<UserSettings> => {
    const response = await apiClient.put<ApiResponse<UserSettings>>('/v1/user/settings', settings);
    return response.data.data;
  },
};
